import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Row, Button } from 'antd';
import 'antd/dist/antd.css';
import i18n from '../../config/i18n';
import QuestionView from './QuestionView';

class SummaryView extends Component {
  static propTypes = {
    recommendation: PropTypes.shape({
      timestamp: PropTypes.string.isRequired,
      totalScore: PropTypes.number,
      risk: PropTypes.string,
      recommendation: PropTypes.string,
    }).isRequired,
    questionSet: PropTypes.arrayOf(PropTypes.shape({
      question: PropTypes.shape({
        mainText: PropTypes.string,
        secondaryText: PropTypes.string,
        questionType: PropTypes.string,
        questionGroup: PropTypes.string,
        sequence: PropTypes.number,
      }),
      selectedAnswers: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        mainText: PropTypes.string,
        secondaryText: PropTypes.string,
        score: PropTypes.number,
        renderAnswerType: PropTypes.string,
        sequence: PropTypes.number,
      })),
    })).isRequired,
    nextPhase: PropTypes.func.isRequired,
    askAdditionalQuestions: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    questionSet: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      answers: [],
    };
  }

  getQuestionView = (questions, index, disableInput, answerSet) => (
    <QuestionView
      item={questions[index]}
      index={index}
      save={this.setAnswer} // do nothing for saving
      key={index}
      savedAnswers={answerSet}
      disableInput={disableInput}
    />
  );

  getAdditionalQuestionsView = (questions, resumeAnswerSet) => questions.map(
    (item, index) => this.getQuestionView(questions, index, false, resumeAnswerSet)
  );

  setAnswer = (questionType, answer, index) => {
    if (questionType && answer) {
      const { questionSet } = this.props;
      const { answers } = this.state;

      // format answers for saving
      const toSave = {
        questionType,
        selectedAnswers: answer.map(rowIndex => questionSet[index].answers[rowIndex]),
        selectedRows: answer,
        answerOfQuestion: index,
      };

      // construct new array for overwriting existing answers
      const newAnswers = [...answers];

      // overwrite answers if already exist
      newAnswers[index] = toSave;

      this.setState({ answers: newAnswers });
    }
  };

  complete = () => {
    const { answers } = this.state;
    const { nextPhase } = this.props;
    nextPhase(answers);
  };

  render() {
    const { answers } = this.state;
    const {
      recommendation: {
        timestamp,
        totalScore,
        risk,
        recommendation,
      },
      questionSet,
      askAdditionalQuestions,
    } = this.props;
    const summaryRow = [
      {
        title: 'Date',
        width: 400,
        dataIndex: 'timestamp',
      },
      {
        title: 'Total Score',
        dataIndex: 'totalScore',
      },
    ];
    const infoRow = [
      {
        key: 0,
        timestamp: moment(timestamp).format('YYYY-MM-DD hh:mm:ss A'),
        totalScore,
      },
    ];
    const riskRow = [
      {
        title: 'Risk',
        width: 400,
        dataIndex: 'risk',
      },
      {
        title: 'Recommendation',
        dataIndex: 'text',
      },
    ];
    const recommendationRow = [
      {
        key: 0,
        risk,
        text: recommendation,
      },
    ];
    return (
      <div>
        <div>
          <Table
            bordered
            columns={riskRow}
            size="middle"
            dataSource={recommendationRow}
            pagination={false}
          />
          <br />
          <Table
            bordered
            columns={summaryRow}
            dataSource={infoRow}
            size="middle"
            pagination={false}
          />
        </div >
        <br />
        <div>
          {askAdditionalQuestions ? this.getAdditionalQuestionsView(questionSet, answers) : null}
        </div>
        <br />
        <Row type="flex" justify="center">
          <Button
            type="primary"
            size={'large'}
            onClick={this.complete}
          >
            {i18n.t('complete')}
          </Button>
        </Row>
      </div>
    );
  }
}

export default SummaryView;



// WEBPACK FOOTER //
// ./src/components/fpp/SummaryView.js